

export const autoCompleteStyle = { 
    width: 180, 
    backgroundColor: "rgba(255, 255, 255, 0.9)", // Semi-transparent white for glass effect
    borderRadius: "30px",
    boxShadow: "0px 4px 12px rgba(117, 117, 117, 0.5)", // Drop shadow
    backdropFilter: "blur(8px)" // Glass effect: blur
  }
  
  export const autoCompleteTextFieldStyle = { 
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none" // Removes the border
      },
      "&:hover fieldset": {
        border: "none" // Removes border on hover
      },
      "&.Mui-focused fieldset": {
        border: "none" // Removes border when focused
      }
    }
  }
  
export const selectFieldStyle = { 
    width: 180, 
    backgroundColor: "rgba(255, 255, 255, 0.9)", // Semi-transparent white for glass effect
    borderRadius: "30px",
    boxShadow: "0px 4px 12px rgba(117, 117, 117, 0.5)", // Drop shadow
    backdropFilter: "blur(8px)" // Glass effect: blur
  }

export const textFieldStyle = {
  "& .MuiOutlinedInput-root": {
    width: 180,  // Sets the width of the input
    backgroundColor: "rgba(255, 255, 255, 0.9)",  // Semi-transparent white for glass effect
    borderRadius: "30px",  // Makes the input more rounded
    boxShadow: "0px 4px 12px rgba(117, 117, 117, 0.5)",  // Adds a drop shadow
    backdropFilter: "blur(8px)",  // Applies a glass effect with blur
    "& fieldset": {
      border: "none"  // Removes the border
    },
    "&:hover fieldset": {
      border: "none"  // Removes the border on hover
    },
    "&.Mui-focused fieldset": {
      border: "none"  // Removes the border when focused
    }
  }
}